import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

import {
  Avatar,
  Button,
  ButtonGroup,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  InputAdornment,
  IconButton,
  Link
} from '@material-ui/core';

import { LockOutlined, Visibility, VisibilityOff } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  langGroup: {
    marginTop: theme.spacing(3),
  },
}));

const Login = () => {
  const classes = useStyles();

  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [currentLang, setCurrentLang] = useState(
    (i18n.language || localStorage.getItem("i18nextLng") || "es").toLowerCase().startsWith("ca") ? "ca" : "es"
  );

  const { handleLogin } = useContext(AuthContext);

  const handleChangeLanguage = (lang) => {
    localStorage.setItem("i18nextLng", lang);
    i18n.changeLanguage(lang);
    setCurrentLang(lang);
  };

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handlSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget || e.target;
    const email = (form.elements?.email?.value || user.email || "").trim();
    const password = form.elements?.password?.value || user.password || "";
    handleLogin({ email, password });
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlined />
        </Avatar>
        <Typography component="h1" variant="h5">
          {i18n.t("login.title")}
        </Typography>
        <form className={classes.form} noValidate onSubmit={handlSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label={i18n.t("login.form.email")}
            name="email"
            value={user.email}
            onChange={handleChangeInput}
            autoComplete="email"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label={i18n.t("login.form.password")}
            id="password"
            value={user.password}
            onChange={handleChangeInput}
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword((e) => !e)}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {i18n.t("login.buttons.submit")}
          </Button>
          <Grid container>
            <Grid item>
              <Link
                href="#"
                variant="body2"
                component={RouterLink}
                to="/signup"
              >
                {i18n.t("login.buttons.register")}
              </Link>
            </Grid>
          </Grid>
        </form>

        <Box display="flex" justifyContent="center" alignItems="center" className={classes.langGroup}>
          <ButtonGroup size="small" variant="outlined">
            <Button
              color={currentLang === "ca" ? "primary" : "default"}
              variant={currentLang === "ca" ? "contained" : "outlined"}
              onClick={() => handleChangeLanguage("ca")}
              style={{ textTransform: "none", fontWeight: currentLang === "ca" ? "bold" : "normal" }}
            >
              🟡🔴 Català
            </Button>
            <Button
              color={currentLang === "es" ? "primary" : "default"}
              variant={currentLang === "es" ? "contained" : "outlined"}
              onClick={() => handleChangeLanguage("es")}
              style={{ textTransform: "none", fontWeight: currentLang === "es" ? "bold" : "normal" }}
            >
              🇪🇸 Castellano
            </Button>
            <Button
              color={currentLang === "en" ? "primary" : "default"}
              variant={currentLang === "en" ? "contained" : "outlined"}
              onClick={() => handleChangeLanguage("en")}
              style={{ textTransform: "none", fontWeight: currentLang === "en" ? "bold" : "normal" }}
            >
              🇬🇧 English
            </Button>
          </ButtonGroup>
        </Box>
      </div>
      <Box mt={8}>{/* <Copyright /> */}</Box>
    </Container>
  );
};

export default Login;
